module.exports = __webpack_public_path__ + "img/home_news_bg.2924a107.jpg";